import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { IItemDetails } from '../../common/interfaces/dtos/IItemDetails';
import { styles } from './price-entry-styles';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { PriceEntryType } from 'src/common/enumerations/price-entry-type';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { getQuantity, getUnitsOfMeasure } from '../business-logic/handle-price-verify-required';

const PriceVerificationRequiredSubText = ({
  itemDetails,
  priceEntryType,
  hidePrice = false,
}: PriceVerificationRequiredSubTextProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const isLeftHanded = CashierPreferencesHelper.isLeftHanded();
  const isPriceShown =
    !hidePrice &&
    [PriceEntryType.PriceVerify, PriceEntryType.PriceRequired].includes(priceEntryType);

  return (
    <Grid container direction='column' alignItems={isLeftHanded ? 'flex-end' : 'flex-start'}>
      <Grid item data-testid='item-description' className={classes.contentItemNameSubText}>
        {itemDetails.description}
      </Grid>
      {isPriceShown && (
        <Grid item data-testid='item-price' className={classes.contentItemCodeSubText}>
          <span className={classes.currencyText}>{convertCurrency(itemDetails.price)}</span>
          {` / ${getQuantity(itemDetails)}${t(getUnitsOfMeasure(itemDetails))}`}
        </Grid>
      )}
      <Grid item data-testid='item-id' className={classes.contentItemCodeSubText}>
        {`${t('ItemLabel')} ${itemDetails.itemId}`}
      </Grid>
    </Grid>
  );
};

interface PriceVerificationRequiredSubTextProps {
  itemDetails: IItemDetails;
  priceEntryType: PriceEntryType;
  hidePrice?: boolean;
}

export default PriceVerificationRequiredSubText;
